export enum MDX_MANAGER_FILE_TYPE {
  POSTS = "posts",
  AUTHORS = "authors",
  CATEGORIES = "categories",
  DRAFTS = "drafts",
}

export interface TFile {
  content?: string | undefined;
  slug: string;
}

export interface IMDXManagerGetFileParams {
  type: MDX_MANAGER_FILE_TYPE;
  slug: string;
  extension?: string;
  withoutBody?: boolean;
}

export interface IMDXManagerGetFilesParams {
  type: MDX_MANAGER_FILE_TYPE;
  extension?: string;
}

export interface IMDXManagerSerializeFileParams {
  file: any;
}

export interface IMDXManager {
  getFile<T extends TFile>(params: IMDXManagerGetFileParams): T;
  getFiles<T extends TFile>(params: IMDXManagerGetFilesParams): Array<T>;
  serializeFile<T extends TFile>(
    params: IMDXManagerSerializeFileParams
  ): Promise<T>;
}

export interface IMDX_Frontmatter {
  slug: string;
  content?: string;
}

export type IImageProviders = "default" | "cloudinary";

export interface IPostFrontMatter extends TFile {
  title: string;
  excerpt: string | undefined;
  content?: any | undefined; // TODO: Type as a MDX Whatever
  imageUrl: string;
  imageProvider: IImageProviders;
  category: string;
  tags?: string[];
  createdAt: string;
  updatedAt?: string;
  author: string;
  url: string;
  urlSlug: string;
}

export interface IAuthorFrontMatter extends TFile {
  name: string;
  url: string;
  description?: string;
}

export interface ICategoryFrontMatter extends TFile {
  name: string;
}
